module.exports = __webpack_public_path__ + "static/img/mm.92e9f832.svg";